var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gat-flex',{attrs:{"size":"xs12"}},[_c('documents',{attrs:{"location":_vm.location,"parentId":_vm.parentId,"embedded":"true","compact":_vm.compact,"disabled":_vm.disabled},on:{"file-selected":_vm.selectedFiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }